import { revokeToken } from "./auth";

export const paymentLink  = process.env.REACT_APP_PAYMENT_LINK || "https://buy.stripe.com/test_fZe3cDbOo2IC1Tq9AC";

export function buyEarlyAccess() {
    revokeToken(); 
    window.location = paymentLink;
}